// var swiper = new Swiper('.shopify-section--blog-posts .swiper-container', {
//     loop: false,
//     spaceBetween: 8,
//     slidesPerView: 1.01,
//     navigation: {
//         nextEl: '.swiper-button-next',
//         prevEl: '.swiper-button-prev'
//     },
//     pagination: {
//         el: '.swiper-pagination',
//         clickable: true
//     },
//     breakpoints: {
//         768: {
//             slidesPerView: 3.3, // For screens smaller than 1024px
//         }
//     }
// });
var swiper = new Swiper('.shopify-section--blog-posts .swiper-container', {
    loop: false,
    spaceBetween: 8,
    slidesPerView: 1.01,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
    },
    pagination: {
        el: '.swiper-pagination',
        clickable: true
    },
    breakpoints: {
        768: {
            slidesPerView: 3.3,
            enabled: true   // Re-enable slider on desktop
        }
    },
    enabled: false          // Disabled (stacked) on mobile
});

if (!window.location.pathname.includes('/collections/')) {
var swiper = new Swiper('.shopify-section--featured-collection .swiper-container', {
    loop: false,
    spaceBetween: 12,
    slidesPerView: 1.2, // Default for larger screens
    pagination: {
        el: '.swiper-pagination',
        clickable: true
    },
    breakpoints: {
        1024: {
            slidesPerView: 4, // For screens smaller than 1024px
        },
        767: {
            slidesPerView: 3, // For screens smaller than or equal to 767px
        }
    }
});
}

var swiper = new Swiper('.scrollable-with-controls.swiper-container', {
    loop: true,
    spaceBetween: 12,
    slidesPerView: 1.01, // Default for larger screens
     autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
    pagination: {
        el: '.swiper-pagination',
        clickable: true
    },
    breakpoints: {
        1024: {
            slidesPerView: 3.2, // For screens smaller than 1024px
        },
        767: {
            slidesPerView: 2.5, // For screens smaller than or equal to 767px
        }
    }
});


